import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { InvoiceGenerationModal } from './components/invoice-generation-modal';

interface IInvoiceGenerationProps {
  invoiceId: number;
}

export const InvoiceGenerationComponent: React.FC<IInvoiceGenerationProps> = (props) => {
  const { invoiceId } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<CopyOutlined />} onClick={handleOpen}>
        {t('invoice:invoice')}
      </Button>
      <InvoiceGenerationModal isOpen={isModalOpen} invoiceId={invoiceId} onClose={handleClose} />
    </>
  );
};

export const InvoiceGeneration = withRoleGuard<IInvoiceGenerationProps>(InvoiceGenerationComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
